export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_check.a7017b4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};